var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import { observable, action } from 'mobx';
import { Context } from '@greycat/core';
import LineChartStore from './charts/LineChartStore';
import BarChartStore from './charts/BarChartStore';
export default class ChartsStore {
    constructor(_graph, _console) {
        this._graph = _graph;
        this._console = _console;
        this.lines = new Map();
        this.bars = new Map();
        // Studio Chart Functions declaration
        this._graph.declareFunction('line_chart', this.createLineChart);
        this._graph.declareFunction('bar_chart', this.createBarChart);
    }
    createLineChart(ctx) {
        const id = ctx.get('id');
        const x = ctx.get('x');
        const y = ctx.get('y');
        if (id && typeof x === 'number' && typeof y === 'number') {
            let chartStore = this.lines.get(id);
            if (!chartStore) {
                const xAxis = ctx.get('xAxis') || 'x';
                const yAxis = ctx.get('yAxis') || 'y';
                chartStore = new LineChartStore(id, xAxis, yAxis);
                this.lines.set(id, chartStore);
            }
            const lineId = ctx.get('lineId') || undefined;
            chartStore.addPoint(x, y, lineId);
        }
        else {
            this._console.warn("line_chart(id: string, x: number, y: number) should be called with valid 'id', 'x' and 'y' parameters");
        }
    }
    createBarChart(ctx) {
        const id = ctx.get('id');
        const series = ctx.get('series');
        // tslint:disable-next-line:no-console
        console.log('series', JSON.parse(JSON.stringify(series)));
        if (id && series) {
            const store = new BarChartStore(id, 'index', series);
            this.bars.set(id, store);
        }
        else {
            this._console.warn("bar_chart(id: string) should be called with a valid 'id'");
        }
        // const id = ctx.get<string>('id');
        // const indexBy = ctx.get<string>('indexBy');
        // if (id && typeof x === 'number' && typeof y === 'number') {
        //   let chartStore = this.bars.get(id);
        //   if (!chartStore) {
        //     chartStore = new BarChartStore(id, indexBy);
        //     this.bars.set(id, chartStore);
        //   }
        //   const lineId = ctx.get<string>('lineId') || undefined;
        //   chartStore.addPoint(x, y, lineId);
        // } else {
        //   this._console.warn("bar_chart(id: string, x: number, y: number) should be called with valid 'id', 'x' and 'y' parameters");
        // }
    }
    deleteChart(id) {
        this.lines.delete(id);
    }
}
__decorate([
    observable,
    __metadata("design:type", typeof (_a = typeof Map !== "undefined" && Map) === "function" ? _a : Object)
], ChartsStore.prototype, "lines", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_b = typeof Map !== "undefined" && Map) === "function" ? _b : Object)
], ChartsStore.prototype, "bars", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_c = typeof Context !== "undefined" && Context) === "function" ? _c : Object]),
    __metadata("design:returntype", void 0)
], ChartsStore.prototype, "createLineChart", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_d = typeof Context !== "undefined" && Context) === "function" ? _d : Object]),
    __metadata("design:returntype", void 0)
], ChartsStore.prototype, "createBarChart", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ChartsStore.prototype, "deleteChart", null);
